module.exports = __webpack_public_path__ + "static/media/mario.3b5f5d68.svg";